import requestOptions from '../functions/services/requestOptions'

export const logError = async (errorMessage, env = 2) => {
  try {
    const stack = new Error().stack
    const lines = stack.split('\n')

    const callerLine = lines[2] || '' // Línea que llamó al error
    const match = callerLine.match(/at\s+([^\s]+)\s+\(([^)]+)\)/)

    let sectionError = match?.[1] || 'unknownFunction'
    if (sectionError.includes('.')) {
      sectionError = sectionError.split('.').pop()
    }

    let moduleTrans = match?.[2]?.split('/').pop() || 'unknownFile'
    if (moduleTrans.includes(':')) {
      moduleTrans = moduleTrans.split(':')[0]
    }

    const body = {
      env,
      error: errorMessage,
      sectionError,
      moduleTrans
    }

    const options = requestOptions.options('POST', '', body)
    const resp = await fetch(global.ERROR_LOG_ENDPOINT, options)

    if (!resp.ok) {
      console.warn('[LOG ERROR FALLBACK]', body)
    }
  } catch (err) {
    console.error('Error al intentar registrar el error:', err)
    console.error('[ERROR ORIGINAL]', errorMessage)
  }
}
